<template>
  <canvas
    style="width: 100%;  height: 300px; display: block; border: thin dashed black;"
    :id="`c_${partUUID}`"
  ></canvas>
</template>

<script lang="js">
import Vue from 'vue';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { BACKEND_URL } from '@/za_conf';

export default Vue.extend({
  props: ['partUUID'],
  // type inference enabled
  data() {
    return {};
  },
  mounted() {
    const canvas = document.querySelector(`#c_${this.partUUID}`);
    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });

    const fov = 50;
    const aspect = 1; // the canvas default
    const near = 0.1;
    const far = 20;

    const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);

    const controls = new OrbitControls(camera, canvas);
    controls.update();

    const scene = new THREE.Scene();
    scene.background = new THREE.Color('white');

    {
      const color = 0xffffff;
      const intensity = 1;
      const light = new THREE.DirectionalLight(color, intensity);
      const light2 = new THREE.DirectionalLight(color, intensity);
      const light3 = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4);
      light2.position.set(-1, 2, -4);
      light3.position.set(5, 0, 4);
      //light4.position.set(-1, -2, 4);
      scene.add(light);
      scene.add(light2);
      scene.add(light3);
      // scene.add(light4);
    }

    function frameArea(sizeToFitOnScreen, boxSize, boxCenter, camera) {
      const halfSizeToFitOnScreen = sizeToFitOnScreen * 0.5;
      const halfFovY = THREE.MathUtils.degToRad(camera.fov * 0.5);
      const distance = halfSizeToFitOnScreen / Math.tan(halfFovY);
      // compute a unit vector that points in the direction the camera is now
      // in the xz plane from the center of the box
      boxCenter = boxCenter.add(new THREE.Vector3(0.00001, 0.000001, 0.000001))
      const direction = new THREE.Vector3()
        .subVectors(camera.position, boxCenter)
        .multiply(new THREE.Vector3(1, 0, 1))
        .normalize();

      // move the camera to a position distance units way from the center
      // in whatever direction the camera was from the center already
      camera.position.copy(direction.multiplyScalar(distance).add(boxCenter));

      // pick some near and far values for the frustum that
      // will contain the box.
      camera.near = boxSize / 100;
      camera.far = boxSize * 100;

      camera.updateProjectionMatrix();

      // point the camera to look at the center of the box
      camera.lookAt(boxCenter.x, boxCenter.y, boxCenter.z);
    }

    {
      const gltfLoader = new GLTFLoader();
      gltfLoader.setWithCredentials(true);
      gltfLoader.load(`${BACKEND_URL}/gltf/${this.partUUID}`, gltf => {
        const root = gltf.scene;
        scene.add(root);
        // compute the box that contains all the stuff
        // from root and below
        const box = new THREE.Box3().setFromObject(root);

        const boxSize = box.getSize(new THREE.Vector3()).length();
        const boxCenter = box.getCenter(new THREE.Vector3());

        // set the camera to frame the box
        frameArea(boxSize * 1.1, boxSize, boxCenter, camera);

        // update the Trackball controls to handle the new size
        controls.maxDistance = boxSize * 10;
        controls.target.copy(boxCenter);
        controls.update();
      });
    }

    function resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
      }
      return needResize;
    }

    function render() {
      if (resizeRendererToDisplaySize(renderer)) {
        const canvas = renderer.domElement;
        camera.aspect = canvas.clientWidth / canvas.clientHeight;
        camera.updateProjectionMatrix();
      }

      renderer.render(scene, camera);

      requestAnimationFrame(render);
    }

    requestAnimationFrame(render);
  }
});
</script>

<style scoped>
html,
body {
  margin: 0;
  height: 100%;
}
</style>
